"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2C9.45 2 6 5.62 6 12.45c0 8.62 9 16.94 9.33 17.29l.67.62.68-.62c.38-.35 9.32-8.67 9.32-17.29C26 5.62 22.54 2 16 2zm0 25.6c-2-2.08-8-8.71-8-15.15C8 6.77 10.61 4 16 4s8 2.77 8 8.45c0 6.44-6 13.07-8 15.15z" }),
        React.createElement("path", { d: "M16 7.5a5 5 0 105 5 5 5 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z" })));
}
exports.default = SvgLocationOutline;
//# sourceMappingURL=LocationOutline.js.map